export default __webpack_public_path__ + "static/media/music.ae74d9b6.png";